/** @format */

import React, { useEffect, useMemo, useState } from 'react';
import { Header } from './Header';
import './App.css';

import { DirectLine } from 'botframework-directlinejs';
import ReactWebChat, {
  createDirectLine,
  createStyleSet,
} from 'botframework-webchat';
import attachmentMiddlewareWithDL from './middlewares/attachmentMiddleware';
import cardActionMiddleware from './middlewares/cardActionMiddleware';
import {
  getCookie,
  setCookie,
  deleteAllCookies,
} from './cookieHelper/cookieHelper';
import {
  getSettingsFromBackend,
  getSettingsFromBackendWithConversationId,
  BotSettings,
} from './backendAccess/backendAccess';

import { useExternalScript } from './helpers/useExternalSkript';

import { Helmet } from 'react-helmet';
import { makeid, generateId } from './helpers/userIdHelper';

function App() {
  const [directLine, setDirectline] = useState<DirectLine | undefined>();
  const [conversationId, setConversationId] = useState<string>('');
  const [botSettings, setBotSettings] = useState<BotSettings | undefined>();
  const [userId, setUserId] = useState<string>('abcdef');
  const [locale, setLocale] = useState<string>('');
  const [path, setPath] = useState<string>('/');

  //const [watermark, setWatermark] = useState<string>('');

  const state = useExternalScript(botSettings?.customJsUrl);

  const getConfigMiddleware = function () {
    return function (next: any) {
      return function (activity: any) {
        ////console.log('ACTIVITY');
        try {
          let convID = activity.activity.conversation.id;
          if (conversationId !== convID) setConversationId(convID);

          if (botSettings !== undefined)
            setCookie(botSettings.cidCookieName, conversationId);

          let wm = activity.activity.id;
          let r = wm.split('|');

          //setWatermark(r[1]);
          let tmpwm = getCookie('watermark');
          if (tmpwm === null || tmpwm === '') {
            // if no watermark in cookie set it with the last collected one
            setCookie('watermark', r[1]);
          }
          // else {
          //   // if watermark in cookie, take this
          //   //setWatermark(tmpwm);
          // }

          let z = next(activity);
          return z;
        } catch (error) {
          next(activity);
        }
      };
    };
  };

  // first task is to get the settings from the backend
  useEffect(() => {
    getSettingsFromBackend().then((settings) => {
      // //console.log(settings);
      // //console.log('cookiename:' + settings.cidCookieName);
      let cid = getCookie(settings.cidCookieName);
      ////console.log('cid:' + cid);
      if (cid !== null && cid !== '') {
        getSettingsFromBackendWithConversationId(cid).then((settings) => {
          setBotSettings(settings);
          setCookie('token', settings.token);
        });
      } else {
        setBotSettings(settings);
        setCookie('token', settings.token);
      }
    });
  }, []);

  useEffect(() => {
    if (botSettings != null && directLine != null && conversationId != null) {
      setCookie(botSettings.cidCookieName, conversationId);
      setCookie(botSettings.uidCookieName, userId);
      // //console.log('set cookies');
      // //console.log('setting cookie cid:' + conversationId);
      // //console.log('setting cookie uid:' + userId);
    }
  }, [botSettings, conversationId]);

  useEffect(() => {
    //console.log('path changed:' + window.location.pathname);
    //console.log('path changed:' + path);
      if (window.location.pathname != path) {
          let lang = window.location.pathname.toLowerCase();
      let pathparts = lang.split('/');

      let country = pathparts.length >= 3 ? pathparts[1] : 'us';
      let locale = pathparts.length >= 3 ? pathparts[2] : 'en';
      let reset = pathparts.length >= 4 ? pathparts[3] : 'empty';

      if (reset === 'r') {
        //console.log('reset has r');
        //setCookie('locale', locale + '-' + country);
        //alert('path changed:' + window.location.pathname);

        //console.log(
        //   'redirect to ' +
        //     pathparts[0] +
        //     '/' +
        //     pathparts[1] +
        //     '/' +
        //     pathparts[2]
        // );
        window.location.replace(
          pathparts[0] + '/' + pathparts[1] + '/' + pathparts[2]
        );
      }

      if (country === null) country = 'us';
      if (locale === null) locale = 'en';

      //alert(locale);

      let cookieLocale = getCookie('locale');
      // if no cookie, set initial cookie value
      if (cookieLocale == null) {
        //console.log('initial locale setting:' + locale + '-' + country);
          setCookie('locale', locale.toLowerCase() + '-' + country.toLowerCase());
      }

      // if on site and path changed, delete cookies
      else {
          //alert('cookielocale:' + cookieLocale);
          if (cookieLocale != null && cookieLocale != locale.toLowerCase() + '-' + country.toLowerCase()) {
          //console.log('locale has changed');
          //setCookie('locale', locale + '-' + country);
          //alert('path changed:' + window.location.pathname);
          //console.log('deleting cookies');
          deleteAllCookies.then((dings) => {
            //console.log('cookies deleted');
            //console.log('reloading');
            window.location.reload();
          });
        }
        }
        setLocale(locale.toLowerCase() + '-' + country.toLowerCase());
      //alert('window.location.pathname:' + window.location.pathname);
      //alert('path:' + path);
      setPath(window.location.pathname.toLowerCase());
    }
  }, [window.location.pathname]);

  // useEffect(() => {
  //   alert(locale);
  //   let cookieLocale = getCookie('locale');
  //   if (cookieLocale != locale) {
  //     // if (locale != locale + '-' + country) {
  //     //   alert('set locale: ' + locale + '-' + country);
  //     //   setLocale(() => locale + '-' + country);
  //     // }
  //   }
  // }, [locale]);

  useEffect(() => {
    if (typeof botSettings !== 'undefined') {
      if (typeof directLine === 'undefined' || directLine === null) {
        // 1. try to get cookies and cid, uid
        if (
          botSettings != null &&
          botSettings.cidCookieName != null &&
          botSettings.cidCookieName != '' &&
          botSettings.uidCookieName != null &&
          botSettings.uidCookieName != ''
        ) {
          let cid = getCookie(botSettings.cidCookieName);
          ////console.log('retrieved cookiesetting cid:' + cid);
          if (cid != null && cid !== '') setConversationId(cid);

          let uid = getCookie(botSettings.uidCookieName);
          ////console.log('retrieved cookiesetting uid:' + uid);
          if (uid != null && uid !== '') setUserId(uid);
          else setUserId(generateId(userId, botSettings));

          let wm = getCookie('watermark');

          // 2. connect to DL (if possible to loaded cookies)
          createDL(cid !== null ? cid : '', uid !== null ? uid : ''); // make sure there is a string and not null
        }
      }
    } //else// alert('botsettings is undefined');
  }, [botSettings]);

  // this function creteated the directline object
  function createDL(cid: string, uid: string) {
    //alert('creating directline with token:' + botSettings?.token);
    let dl: DirectLine;
    let token = getCookie('token');
    let wm = getCookie('watermark');
    if (cid !== '') {
      // we have a converaationId from cookie, so reconnect
      //console.log('reconnecting to conversation cid: ' + cid);
      //console.log('reconnecting to conversation watermark: ' + wm);
      ////console.log('streamurl>>> ' + botSettings?.streamUrl);
      dl = new DirectLine({
        token: botSettings?.token,
        conversationId: cid,
        //domain: 'https://directline.botframework.com/v3/directline',
        //webSocket: true,
        //streamUrl: botSettings?.streamUrl,
        watermark: '0000000',
      });
    } else {
      //console.log('creating a new conversation');
      // we have no old conversation id, so create a brandnew directlineconnection
      dl = new DirectLine({
        token: botSettings?.token,
        domain: 'https://directline.botframework.com/v3/directline',
        webSocket: true,
      });
    }

    // dl.activity$.subscribe((activity) => {
    //   //console.log('received activity ', activity);
    // });

    //console.log('created directline object');
    dl.connectionStatus$.subscribe((state) => {
      switch (state) {
        case 0:
          //console.log('dl uninitialized');
          break;
        case 1:
          //console.log('dl connecting');
          break;
        case 2:
          //console.log('dl connected');

          //console.log('dl sending event');
          ////console.log(dl);

          let lang = window.location.pathname;
          let pathparts = lang.split('/');

          let country = pathparts.length >= 3 ? pathparts[1] : 'us';
          let locale = pathparts.length >= 3 ? pathparts[2] : 'en';

          if (country === null) country = 'us';
          if (locale === null) locale = 'en';

          setLocale(() => locale + '-' + country);

          dl.postActivity({
            type: 'event',
              name: 'UserLocaleEvent',
              value: country.toLowerCase() + '|' + locale.toLowerCase() + '|' + botSettings?.userAccessLevel,
            from: {
              id: 'abcdef',
            },
          })
            .toPromise()
            .then(() => {
              //console.log('dl event send');
            });
          break;
        case 3:
          //console.log('dl expired');
          let tok: any = getCookie('token');
          dl.reconnect({
            conversationId: conversationId,
            token: tok,
          });
          break;
      }
    });
    //console.log('subscribed to dl connectionstatus');
    setDirectline(dl);
    return dl;
  }

  function getHeightOfWebChat(): string {
    return botSettings !== undefined &&
      botSettings.showTitleBar.toLowerCase() === 'true'
      ? 'calc(100%-20px)'
      : '100%';
  }
  // render the component (conditional render is used to hide botchat until ready)
  return (
    <div
      id='outerwebchat'
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <link rel='stylesheet' type='text/css' href={botSettings?.customCssUrl} />
      {botSettings != null &&
      botSettings.showTitleBar.toLowerCase() === 'true' ? (
        <div>
          <Header />
        </div>
      ) : (
        <div></div>
      )}

      <div
        id='webchat'
        style={{
          color: 'black',
          width: '100%',
          height: getHeightOfWebChat(),
          alignSelf: 'flex-start',
        }}
      >
        <Helmet>
          <meta charSet='utf-8' name='WebChat' />
          <title>{botSettings?.webChatTile}</title>

          <link rel='icon' href={botSettings?.favIcon} />
        </Helmet>
        {typeof directLine === 'undefined' || directLine === null ? (
          <div>loading...</div>
        ) : (
          <ReactWebChat
            directLine={directLine}
            userID='abcdef' //{userId}
            username='dl_abcdef' //{'dl_' + userId}
            locale={locale} //'de-DE'
            styleOptions={{
              adaptiveCardsParserMaxVersion: '1.3',
              hideUploadButton: true,
            }}
            attachmentMiddleware={attachmentMiddlewareWithDL(directLine)}
            cardActionMiddleware={cardActionMiddleware(directLine)}
            activityMiddleware={getConfigMiddleware}
            styleSet={createStyleSet({
              bubbleBackground: 'rgba(236, 239, 241, 1)',
              bubbleBorderRadius: 5,
              bubbleFromUserTextColor: 'White',
              bubbleFromUserBackground: 'rgba(1, 145, 220, 1)',
              bubbleFromUserBorderRadius: 5,
              hideUploadButton: true,
            })}
          />
        )}
      </div>
    </div>
  );
}

export default App;
